<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <nh-alert type="warning" [isOpen]="commentBannerMessage">
      <div class="row" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="col-auto icon">
          <img
            src="../../assets/images/Icons/⚛️ icons-warning-outline.svg"
            alt=""
          />
        </div>
        <div class="col message">
          <span class="visually-hidden">{{ "Alert" | globalTranslate }} </span>
          <span [innerHTML]="'COMMENTS_BANNER_MESSAGE' | globalTranslate">
          </span>
        </div>
      </div>
    </nh-alert>

    <!--<h5 class="section-header">{{ 'SUMMARY' | translate }}</h5><hr>-->
    @if (!isPreterm) {
    <p>
      {{ "SUMMARY_TITLE1" | globalTranslate
      }}{{ this.appKeyWord.toLowerCase() | globalTranslate
      }}{{ "SUMMARY_TITLE2" | globalTranslate
      }}{{ this.appKeyWord.toLowerCase() | globalTranslate }}.
    </p>
    } @if (isPreterm) {
    <p>
      {{ "SUMMARY_TITLE1_QFR" | globalTranslate
      }}{{ this.appKeyWord.toLowerCase() | globalTranslate
      }}{{ "SUMMARY_TITLE2_QFR" | globalTranslate
      }}{{ this.appKeyWord.toLowerCase() | globalTranslate }}.
    </p>
    }
    <nh-field
      id="com_comments"
      label
      [mandatory]="false"
      [attr.aria-required]="false"
    >
      <nh-count>
        <textarea
          (input)="onInput($event)"
          maxlength="2000"
          class="form-control"
          name="comments"
          formControlName="comments"
          [attr.aria-label]="'comments' | globalTranslate"
          rows="5"
          autofocus="true"
        ></textarea>
      </nh-count>
    </nh-field>
  </section>
</nh-form>